<template>
  <div class="basic-button">
    <var-style-provider :style-vars="styleVars">
      <var-button
        class="basic-button__button"
        :outline="outline"
        :type="varButtonType"
        :native="nativeType"
        :text="text"
        :disabled="disabled"
        @click="(e) => emit('buttonClick', e)"
        >{{ label }}</var-button
      >
    </var-style-provider>
  </div>
</template>

<script lang="ts" setup>
import './BasicButton.scss';
import { LDTheme } from 'ewi-ui-helpers/types';

export type ButtonType = 'filled' | 'outlined' | 'elevated' | 'text' | 'tonal';

export interface BasicButtonProps {
  buttonType: ButtonType;
  nativeType?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  form?: string;
  label: string;
  theme?: LDTheme;
  loading?: boolean;
}
defineOptions({
  name: 'BasicButton',
});

const props = withDefaults(defineProps<BasicButtonProps>(), {
  theme: 'light',
  nativeType: 'button',
  loading: false,
});

const outline = computed(() => props.buttonType === 'outlined');
const text = computed(() => props.buttonType === 'text');
const varButtonType = computed(() => {
  switch (props.buttonType) {
    case 'filled':
      return 'primary';
    case 'tonal':
      return 'danger';
    default:
      return 'default';
  }
});

const emit = defineEmits<{
  (e: 'buttonClick', event: Event): void;
}>();

const lightTheme = {};

const darkTheme = {};

const styleVars = ref(props.theme === 'light' ? lightTheme : darkTheme);
</script>
